import React, {
  useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Row,
} from 'antd';
import 'antd/dist/antd.css';
import QuestionView from './QuestionView';
import i18n from '../../config/i18n';

const QuestionsMainSet = ({
  resumeAnswerSet,
  questionSet,
  router,
  medicalRecordId,
  nextPhase,
}) => {
  const [answers, setAnswers] = useState(resumeAnswerSet || []);
  const [hasNextClicked, setHasNextClicked] = useState(false);

  const setAnswer = (questionType, answer, index) => {
    if (questionType && answer) {
      // format answers for saving
      const toSave = {
        questionType,
        selectedAnswers: answer.map(rowIndex => questionSet[index].answers[rowIndex]),
        selectedRows: answer,
        answerOfQuestion: index,
      };

      // construct new array for overwriting existing answers
      const newAnswers = [...answers];

      // overwrite answers if already exist
      newAnswers[index] = toSave;
      setAnswers(newAnswers);
    }
  };

  const getQuestionView = (questions, index, disableInput, answerSet, showAlert) => (
    <QuestionView
      item={questions[index]}
      index={index}
      save={setAnswer}
      key={index}
      savedAnswers={answerSet}
      disableInput={disableInput}
      showAlert={showAlert}
    />
  );

  const getAllQuestionView = () => ((questionSet || []).map(
    (unused, index) => getQuestionView(
      questionSet,
      index,
      false,
      answers,

      // Show alert if the user has clicked the next button.
      hasNextClicked && !(answers[index] && answers[index].selectedAnswers.length)
    )
  ));

  const next = () => {
    const isAllQuestionsAnswered = questionSet.reduce((isAnswered, unused, index) => (
      isAnswered
      && answers[index]
      && answers[index].selectedAnswers.length
    ), true);

    if (isAllQuestionsAnswered) {
      nextPhase(answers);
    }

    setHasNextClicked(true);
  };

  const back = () => {
    router.navigate(`/medical-records/${medicalRecordId}`, { trigger: true });
  };

  return (
    <div>
      <div>
        {getAllQuestionView()}
        <br />
      </div>
      <div>
        <Row type="flex" justify="space-between">
          <Button
            type="primary"
            size={'large'}
            onClick={back}
          >
            {i18n.t('backButton')}
          </Button>
          <Button
            type="primary"
            size={'large'}
            onClick={next}
          >
            {i18n.t('nextButton')}
          </Button>
        </Row>
      </div>
    </div>
  );
};

QuestionsMainSet.propTypes = {
  resumeAnswerSet: PropTypes.arrayOf(PropTypes.object),
  questionSet: PropTypes.arrayOf(PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.object),
  })),
  router: PropTypes.shape({
    navigate: PropTypes.func.isRequired,
  }).isRequired,
  medicalRecordId: PropTypes.string.isRequired,
  nextPhase: PropTypes.func.isRequired,
};

QuestionsMainSet.defaultProps = {
  resumeAnswerSet: [],
  questionSet: [],
};


export default QuestionsMainSet;



// WEBPACK FOOTER //
// ./src/components/fpp/QuestionsMainSet.js